import { render, staticRenderFns } from "./TableActionsIcon.vue?vue&type=template&id=9d3b6784&scoped=true&"
import script from "./TableActionsIcon.vue?vue&type=script&lang=ts&"
export * from "./TableActionsIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TableActionsIcon.vue?vue&type=style&index=0&id=9d3b6784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3b6784",
  null
  
)

export default component.exports